"use client";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import type { DietCatalog } from "@/features/diets/types";
import { useCarouselScrollbar } from "@/lib/hooks/use-carousel-scrollbar";
import { DietCatalogCarouselItem } from "./diet-catalog-carousel-item";

export const MAX_VISIBLE_DIETS = 16;

type DietCatalogCarouselSliderProps = {
  diets: DietCatalog[];
  showMenu?: boolean;
  itemListName?: string;
};

export const DietCatalogCarouselSlider = ({
  diets,
  showMenu = false,
  itemListName,
}: DietCatalogCarouselSliderProps) => {
  const {
    count,
    handleScrollbarPointerCancel,
    handleScrollbarPointerDown,
    handleScrollbarPointerMove,
    handleScrollbarPointerUp,
    isDragging,
    scrollbarThumbOffset,
    scrollbarThumbWidth,
    scrollbarTrackRef,
    setApi,
  } = useCarouselScrollbar();

  return (
    <>
      <Carousel
        className="relative"
        opts={{ align: "start", dragFree: true }}
        setApi={setApi}
      >
        <CarouselContent className="gap-3 pl-4">
          {diets.slice(0, MAX_VISIBLE_DIETS).map((diet, index) => (
            <CarouselItem className="basis-74 pl-0" key={diet.id}>
              <DietCatalogCarouselItem
                diet={diet}
                itemListName={itemListName}
                listIndex={itemListName ? index : undefined}
                showMenu={showMenu}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        {!isDragging && (
          <>
            <CarouselNext className="right-2 h-14 w-14 rounded-xl border border-brand-grey2 bg-brand-white text-brand-green2-300 disabled:hidden" />
            <CarouselPrevious className="left-2 h-14 w-14 rounded-xl border border-brand-grey2 bg-brand-white text-brand-green2-300 disabled:hidden" />
          </>
        )}
      </Carousel>

      {count > 1 && (
        <div
          className="relative mt-6 h-1 w-full cursor-pointer touch-none select-none rounded-full bg-brand-grey2"
          onPointerCancel={handleScrollbarPointerCancel}
          onPointerDown={handleScrollbarPointerDown}
          onPointerMove={handleScrollbarPointerMove}
          onPointerUp={handleScrollbarPointerUp}
          ref={scrollbarTrackRef}
        >
          <div
            className="absolute top-0 h-full rounded-full bg-brand-green2-300 transition-all"
            style={{
              left: `${scrollbarThumbOffset}%`,
              width: `${scrollbarThumbWidth}%`,
            }}
          />
        </div>
      )}
    </>
  );
};
